import React from 'react'
import './Dicetray.css';

export default function Dicetray({currentRoll}) {
  return (
    <div className="DicetrayDiv">
        Last roll: {currentRoll[0] !== 0 && currentRoll[0]} {currentRoll[1] !== 0 && currentRoll[1]}
    </div>
  )
}
